import { reactive, toRefs, computed, watch, onMounted } from 'vue'
import { showToast } from '@/util/couponCollection'
import { mobileValidator } from '@/util/regEx.js'
import { useStore } from 'vuex'
import { checkVerificationCode, getVerificationCode } from '@/api/directSales'
import _ from 'lodash'
export const getPhoneParam = (data = [], option) => {
  let dataMobile = data.map(item => ({ id: item?.id, mobile: item?.mobile, delStatusFlag: item?.delStatusFlag }))
  let idMobile = dataMobile.filter(item => item.id && !item?.delStatusFlag)
  let res = []
  const _isAlreadyHas = (arr, obj) => {
    if (!obj.id && obj?.delStatusFlag) {
      return true
    }
    return arr.find(item => item.mobile === obj.mobile)
  }
  for (let index = 0; index < dataMobile.length; index++) {
    const element = dataMobile[index]
    if (element.id || !_isAlreadyHas(idMobile, element)) {
      res.push(element)
    }
  }
  return res
}
export default function AddPhone() {
  const store = useStore()
  const state = reactive({
    isShowDialog: false,
    dialogConfig: {
      title: '绑定手机号',
      confirmButtonText: '确认',
      cancelButtonText: '暂不修改'
    },
    dialogData: { mobile: '', code: '' },
    errorMessage: { mobile: '', code: '' },
    hasGetCode: false,
    getCodePhone: '',
    residueTime: 0,
    residueTimeConstant: 120000,
    loadCode: false,
    hasSuccess: false,
    successData: {}
  })
  onMounted(() => {
    // 初始化重置所有数据-需要
    state.isShowDialog = false
    state.hasSuccess = false
    state.hasGetCode = false
    state.getCodePhone = ''
    state.residueTime = 0
    state.successData = {}
    state.errorMessage = { mobile: '', code: '' }
    state.dialogData = { mobile: '', code: '' }
  })
  watch(
    () => state.dialogData?.code,
    n => {
      if (n.length > 6) {
        state.dialogData.code = n.slice(0, 6)
      }
    }
  )
  const getVerificationCodeParam = option => {
    let { currentCarInfo } = store.state
    return { customerCarId: currentCarInfo?.id, ...option }
  }

  const isShowCountDown = computed(() => state.residueTime > 0)
  const codeBtnDisableBool = computed(() => (isShowCountDown.value ? true : false))
  const addPhoneBtnEvent = () => {
    //console.log('addPhoneBtnEvent--打开弹窗')
    state.isShowDialog = true
    state.hasSuccess = false
    state.hasGetCode = false
    state.getCodePhone = ''
    state.residueTime = 0
    state.successData = {}
    state.errorMessage = { mobile: '', code: '' }
    state.dialogData = { mobile: '', code: '' }
  }
  // 校验手机号
  const checkMobile = (mobile = '') => {
    if (!mobile) {
      state.errorMessage.mobile = '请输入手机号'
      return false
    }
    if (mobile && !mobile.match(mobileValidator)) {
      state.errorMessage.mobile = '请输入正确的手机号'
      return false
    }
    return true
  }

  const getVerificationCodeFn = async data => {
    //console.log('getVerificationCodeFn')
    let mobile = state.dialogData?.mobile ? _.trim(state.dialogData?.mobile) : ''
    let checkMobileRes = checkMobile(mobile)
    if (!checkMobileRes) {
      return false
    }
    state.errorMessage.mobile = ''
    state.loadCode = true
    try {
      // todo-发送请求-获取验证码-定义签名随机数
      let param = getVerificationCodeParam({ mobile })
      let res = await getVerificationCode(param)
      state.hasGetCode = true
      state.getCodePhone = mobile
      state.residueTime = state.residueTimeConstant
    } catch (e) {
      showToast(e.message, '获取验证码失败')
    } finally {
      state.loadCode = false
    }
  }
  const resetCodeStatus = () => {
    //console.log('resetCodeStatus----')
    state.residueTime = 0
    // state.getCodePhone = ''
  }
  const checkUpdateData = async () => {
    //console.log('执行checkUpdateData--校验验证码---')
    let code = state.dialogData?.code ? _.trim(state.dialogData?.code) : ''
    let mobile = state.dialogData?.mobile ? _.trim(state.dialogData?.mobile) : ''
    let checkMobileRes = checkMobile(mobile)
    if (!checkMobileRes) {
      return false
    }
    if (!state.hasGetCode) {
      showToast('请先获取验证码')
      state.dialogData.code = ''
      state.errorMessage.code = '请输入验证码'
      return false
    }
    if (!code) {
      state.errorMessage.code = '请输入验证码'
      return false
    }

    if (state.getCodePhone !== mobile) {
      showToast('手机号已变更，请重新获取验证码')
      state.errorMessage.code = '请重新获取验证码'
      state.hasGetCode = false
      state.residueTime = 0
      state.getCodePhone = ''
      state.dialogData.code = ''
      return false
    }
    state.hasSuccess = false
    state.successData = {}

    try {
      // todo-发送请求，校验code有效性
      let param = getVerificationCodeParam({ mobile, code })
      let res = await checkVerificationCode(param)
      //console.log('远程校验通过---')
      // state.residueTime = 0
      return { code, mobile }
    } catch (e) {
      showToast(e.message, '校验验证码失败')
      return false
    }
  }

  //关闭弹窗
  const beforeCloseDialog = async action => {
    if (action === 'confirm') {
      try {
        let res = await checkUpdateData()
        //console.log('checkUpdateData--res', res)
        if (!res) {
          return false
        }
        showToast('手机号验证成功')
        state.dialogData = { mobile: '', code: '' }
        state.hasGetCode = false
        state.hasSuccess = true
        state.successData = res
        state.getCodePhone = ''
        state.residueTime = 0
        return true
      } catch (e) {
        //console.log(e)
        showToast(e.message, '操作失败')
        return false
      }
    }
    if (action === 'cancel') {
      state.dialogData = { mobile: '', code: '' }
      state.hasGetCode = false
      state.getCodePhone = ''
      state.residueTime = 0
      return true
    }
  }

  return {
    ...toRefs(state),
    addPhoneBtnEvent,
    beforeCloseDialog,
    checkMobile,
    getVerificationCodeFn,
    codeBtnDisableBool,
    isShowCountDown,
    resetCodeStatus
  }
}
